import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {RentalsListHeader} from './components/header/RentalsListHeader'
import {RentalsTable} from './table/RentalsTable'
import {RentalEditModal} from './rental-edit-modal/RentalEditModal'
import { KTCard } from '../../../../_metronic/helpers'
// import {KTCard} from '../../../../../_metronic/helpers'

const RentalsList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <RentalsListHeader />
        <RentalsTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <RentalEditModal />}
    </>
  )
}

const RentalsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <RentalsList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {RentalsListWrapper}
